import { Ref } from "vue";

export default (val: string, element: Ref<HTMLInputElement | undefined>): number | undefined => {
  const value = Number(val);

  if (Number.isNaN(value)) {
    return;
  } else {
    if (element.value && value <= Number(element.value.max) && value >= Number(element.value.min)) {
      return value;
    }
  }
};